import Vue from "vue";
import VueRouter, { RouteConfig, NavigationGuard, Route, RawLocation } from "vue-router";
import store from "@/store/store";
import dirtyness from "@/utilities/Dirtyness";

Vue.use(VueRouter as any); // eslint-disable-line @typescript-eslint/no-explicit-any

let intendedUrl: string | null = null;

// call this in the *component* code (not here in the router setup)
export function beforeRouteLeave(to: Route, from: Route,  next: (to?: string | void | false) => void) {
    if(dirtyness.isDirty && !confirm("Changes may not be saved.  Click cancel to stay on this page.")) {
        return next(false);
    }
    dirtyness.reset();
    return next();
}

const beforeEnterGuard: NavigationGuard = async (to: Route, from: Route, next: (to?: string | void) => void) => {

    //console.log(`### nav guard... signed in=${store.getters.isSignedIn} intendedUrl=${intendedUrl}`);

    if (store.getters.isSignedIn) {
        if (intendedUrl) {
            const url = intendedUrl;
            intendedUrl = null;
            console.log("### nav guard - now logged in - redirect");
            return next(url); // goto stored url
        } else {
            console.log("### nav guard - carry on...");
            return next(); // all is fine
        }
    }

    try {
        // get user from session storage
        await store.dispatch("loadSignedInUser");
    } catch (e) {
        console.log("@@@ loadSignedInUser failed ");
        console.error(e);
    }

    if (store.getters.isSignedIn) {
        console.log("### nav guard - got login ok");
        next();
    } else {
        intendedUrl = to.path; // store entry url before redirect
        console.log("### nav guard - redirect to signin");
        next("/signIn");
    }
};

//
// -- set up the routes
//

const routes: Array<RouteConfig> = [];

routes.push({ path: "/", name: "HomeSignIn", meta: { layout: "blank" }, component: () => import("@/vue/views/SignIn.vue") });
routes.push({ path: "/SignIn", name: "SignIn", meta: { layout: "blank" }, component: () => import("@/vue/views/SignIn.vue") });
routes.push({ path: "/Reset/:key", name: "ResetPassword", meta: { layout: "blank" }, component: () => import("@/vue/views/ResetPassword.vue") });
routes.push({ path: "/Activate/:key", name: "Activate", meta: { layout: "blank" }, component: () => import("@/vue/views/ResetPassword.vue") });

routes.push({ path: "/Home", name: "Home", meta: { layout: "signed-in" }, beforeEnter: beforeEnterGuard, component: () => import("@/vue/views/Home.vue") });
routes.push({ path: "/Info", name: "Info", meta: { layout: "signed-in" }, beforeEnter: beforeEnterGuard, component: () => import("@/vue/views/Info.vue") });
routes.push({ path: "/Repairs", name: "Repairs", meta: { layout: "signed-in" }, beforeEnter: beforeEnterGuard, component: () => import("@/vue/views/Repairs.vue") });
// routes.push({ path: "/Billing", name: "Billing", meta: { layout: "signed-in" }, beforeEnter: beforeEnterGuard, component: () => import("@/vue/views/Billing.vue") });
// routes.push({ path: "/Billing/:status", name:"BillingOutcome", meta: { layout: "signed-in" }, beforeEnter: beforeEnterGuard, component: () => import("@/vue/views/BillingOutcome.vue") });
routes.push({ path: "/MyAccount", name: "MyAccount", meta: { layout: "signed-in" }, beforeEnter: beforeEnterGuard, component: () => import("@/vue/views/Profile.vue") });
routes.push({ path: "/Transactions/:accountID", name: "Transactions", meta: { layout: "signed-in" }, beforeEnter: beforeEnterGuard, component: () => import("@/vue/views/Transactions.vue") });

routes.push({ path: "/Error", name: "Error500", meta: { layout: "blank" }, component: () => import("@/vue/views/Error500.vue") });

// This needs to be the **last** route
routes.push({ path: "*", meta: { layout: "blank" }, component: () => import("@/vue/views/Error404.vue") });

//
// -- create the router
//

const router = new VueRouter({
    mode: "history",
    linkActiveClass: "active",
    linkExactActiveClass: "active",
    base: process.env.BASE_URL,
    routes
});

export function goToIntendedUrl() {
    if (!intendedUrl) router.replace("/Home"); // default in case not defined (?)
    else router.replace(intendedUrl as RawLocation);
}

export default router;
